import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { producaov2 as api } from "../../../services/apis";
import { getUSER } from "../../../services/auth";
import {
  dataEnvio,
  stripHTML,
  putLinkButton,
  verify_mobile,
} from "../../../utils/Utils";
import { Container, Header } from "semantic-ui-react";
import swal from "sweetalert";
import ReactHtmlParser from "react-html-parser";
import MessageSender from "./MessageSender";
import { Draft } from "./styles";

const DuvidasSection = ({ id_duvida, isAdmin, history }) => {
  const [duvida, setDuvida] = useState({});
  const [admin, setAdmin] = useState(false);
  const idPessoa = JSON.parse(localStorage.getItem("USER_NODE")).id;

  useEffect(() => {
    api
      .get(`/ticket/duvida/${id_duvida}`)
      .then(({ data }) => {
        if (!data.visualizada) {
          api
            .put(`/ticket/duvida/${id_duvida}`, { visualizada: 1 })
            .catch((err) => console.error(err));
        }

        data.mensagem = putLinkButton(data.mensagem);

        data.resposta.map((resposta) => {
          resposta.mensagem = putLinkButton(resposta.mensagem);
        });

        setDuvida(data);
      })
      .catch((err) => {
        history.push("/");
      });
    verifyAmin();
  }, []);
  const verifyAmin = async () => {
    await api
      .post("admin/auth")
      .then((res) => {
        setAdmin(true);
      })
      .catch((err) => {
        setAdmin(false);
      });
  };

  const sendResposta = useCallback(
    async (mensagem) => {
      if (!stripHTML(mensagem)) {
        swal(
          "Ops! Resposta não enviada ! :(",
          "Por favor, coloque algum texto",
          "error"
        );

        return;
      }

      const data = {
        id_pessoa: getUSER().id,
        id_duvida,
        mensagem,
        url: "",
      };
      await api.post(`ticket/resposta`, data).then((res) => {
        const is_admin = JSON.parse(localStorage.getItem("_IS_ADM"));

        if (is_admin === true) {
          swal(
            "Resposta enviada com sucesso",
            "O aluno já receberá a sua resposta",
            "success"
          );
        } else {
          swal(
            "Réplica enviada com sucesso",
            "O seu tutor já receberá a sua resposta",
            "success"
          );
        }
      });

      api
        .get(`/ticket/duvida/${id_duvida}`)
        .then(({ data }) => {
          data.mensagem = putLinkButton(data.mensagem);

          data.resposta.map((resposta) => {
            resposta.mensagem = putLinkButton(resposta.mensagem);
          });

          setDuvida(data);
        })
        .catch((err) => {
          history.push("/");
        });
    },
    [duvida]
  );

  if (!duvida || !duvida.pessoa) {
    return null;
  }

  return (
    <Container style={{ marginBottom: "32px" }}>
      <Header
        as="h2"
        dividing
        style={{
          fontFamily: "Montserrat",
        }}
      >
        Dúvida #{duvida.id}
      </Header>

      <div style={{ marginTop: "32px" }}>
        <div style={{ display: "flex" }}>
          <img
            src={
              duvida.pessoa.foto
                ? duvida.pessoa.foto
                : "https://files.voitto.com.br/ftp-files/assets/images/user_default.png"
            }
            style={{ width: "40px", height: "40px", marginRight: "16px" }}
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex" }}>
              <div
                style={{
                  fontWeight: "bold",
                  marginRight: "8px",
                }}
              >
                {duvida.pessoa.nome}
              </div>

              <div style={{ color: "gray" }}>
                {dataEnvio(duvida.data_envio)}
              </div>
            </div>
            <Draft style={{ marginTop: "8px", marginBottom: "8px" }}>
              {ReactHtmlParser(duvida.mensagem)}
            </Draft>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "72px" }}>
        {duvida.resposta &&
          duvida.resposta.map((resposta) => {
            if (!resposta.pessoa) {
              return null;
            }

            return (
              <div style={{ display: "flex", marginBottom: "32px" }}>
                <img
                  src={
                    resposta.pessoa.foto
                      ? resposta.pessoa.foto
                      : "https://files.voitto.com.br/ftp-files/assets/images/user_default.png"
                  }
                  style={{
                    width: "35px",
                    height: "35px",
                    marginRight: "16px",
                  }}
                />

                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ display: "flex" }}>
                    <div style={{ fontWeight: "bold", marginRight: "8px" }}>
                      {resposta.pessoa.nome}
                    </div>

                    <div style={{ color: "gray" }}>
                      {dataEnvio(resposta.data_envio)}
                    </div>
                    {(idPessoa === resposta.pessoa.id || admin === true) && (
                      <Link
                        to={`/online/tickets/${resposta.id_duvida}/editar/${resposta.id}`}
                        style={{
                          marginLeft: "16px",
                        }}
                      >
                        Editar
                      </Link>
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      marginTop: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    <Draft>{ReactHtmlParser(resposta.mensagem)}</Draft>
                  </div>
                </div>
              </div>
            );
          })}
      </div>

      <div style={{ marginTop: "64px" }}>
        <h3
          style={
            verify_mobile()
              ? { textAlign: "center" }
              : { textAlign: "center", fontSize: "24px", padding: "8px" }
          }
        >
          Responder
        </h3>

        <MessageSender sendResposta={sendResposta} />
      </div>
    </Container>
  );
};

export default DuvidasSection;
